<template>
  <div>
    <p>欢迎进入后台管理平台</p>
  </div>
</template>

<script>
    export default {
        name: "main-view"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/mainView.vue